// extracted by mini-css-extract-plugin
module.exports = {"container":"az_yOc","title":"az_zOc","descriptionContainer":"az_AOc","description":"az_BOc"};